export default __webpack_public_path__ + "static/media/Resume.4b095904.pdf";